<template>
    <v-autocomplete v-model="Selected" :disabled="isUpdating" :items="formattedData" color="blue-grey-lighten-2"
        item-title="name" item-value="Id" chips closable-chips multiple persistent-placeholder variant="outlined"
        :placeholder="placeholder" hide-details>
        <template v-slot:chip="{ props, item }">
            <v-chip v-bind="props" :prepend-avatar="item.raw.avatar" :text="item.raw.name"></v-chip>
        </template>
        <template v-slot:item="{ props, item }">
            <v-list-item v-if="!item.value.header && !item.value.divider" v-bind="props"
                :prepend-avatar="item.raw.avatar" :title="item.raw.name">
            </v-list-item>
            <v-list-item-title v-else-if="item.value.header" class="font-weight-bold">
                {{ item.value.header }}
            </v-list-item-title>
            <v-divider v-else-if="item.value.divider"></v-divider>
        </template>
    </v-autocomplete>
</template>
<script>

export default {
    props: {
        modelValue: {},
        items: {
            required: true,
        },
        placeholder: {},
        selectedItems: {},
    },
    data() {
        return {
            Selected: this.modelValue,
        }
    },
    watch: {
        selectedItems(val) {
            this.Selected = val;
        },
        Selected(val) {
            this.$emit('update:modelValue', val);
        },
    },
    computed: {
        formattedData() {
            if (this.items.length > 0) {
                return this.formatItems(this.items);
            }
            return [];
        }
    },
    methods: {
        formatItems(items) {
            const formatted = [];
            
            items = items.sort((a, b) => {
                if (a.parent_category_id === null) return -1;
                if (b.parent_category_id === null) return 1;
                return b.parent_category_id - a.parent_category_id;
            });

            const grouped = items.reduce((acc, item) => {
                if (item.parent_category_id === null) {
                    acc[item.categoryId] = {
                        header: item.name,
                        items: []
                    };
                } else {
                    if (acc[item.parent_category_id]) {
                        acc[item.parent_category_id].items.push(item);
                    }
                }
                return acc;
            }, {});

            Object.values(grouped).forEach((group) => {
                formatted.push({ header: group.header });

                group.items.forEach((item) => {
                    formatted.push({
                        name: item.name,
                        Id: item.categoryId,
                        group: group.header,
                    });
                });

                formatted.push({ divider: true });
            });

            return formatted;
        }
    },
}
</script>
